import { AvaSuburbHours, TradingHoursReturnType } from '@models';
import moment, { Moment } from 'moment';

const timeRangeToObject = (value: Moment, firstTime: Moment, secondTime: Moment, isDisabled?: boolean): TradingHoursReturnType => ({
  label: `${firstTime.format('LT')} - ${secondTime.format('LT')}`,
  value: value.format(),
  isDisabled,
});

export const getAvailableFutureDeliveryTimes = (selectedDay: Moment, suburbHours: AvaSuburbHours) => {
  const day = selectedDay.format('dddd');
  // Flag to check if parsing the time ranges is done
  let isFinished = false;
  const timeRangeList: TradingHoursReturnType[] = [];
  const avaDay = suburbHours?.ecom_trading_hours.find((d) => d.day === day);
  const avaDayOpen = moment(avaDay?.open, ['h:mm A']);
  const avaDayClose = moment(avaDay?.closed, ['h:mm A']);

  const currentDate = moment();

  let openingTimeMoment = selectedDay.clone().set({ hour: avaDayOpen.get('hours'), minute: avaDayOpen.get('minute'), second: 0 });
  let closingTimeMoment = selectedDay.clone().set({ hour: avaDayClose.get('hours'), minute: avaDayClose.get('minute'), second: 0 });

  if (closingTimeMoment.minute() === 15 || closingTimeMoment.minute() === 45) {
    closingTimeMoment = closingTimeMoment.add(15, 'minute');
  }

  // If shop closes in AM hours, timestamp for closing time should be the following day.
  if (closingTimeMoment.isBefore(openingTimeMoment)) {
    closingTimeMoment = closingTimeMoment.add(1, 'day');
  }

  const startMinutes = openingTimeMoment.minute();

  if (startMinutes > 0 && startMinutes < 30) {
    openingTimeMoment = openingTimeMoment.minute(30);
  }

  if (startMinutes > 30) {
    openingTimeMoment = openingTimeMoment.add(60 - startMinutes, 'minute');
  }

  let newParsedOpen = openingTimeMoment;

  while (!isFinished) {
    const rawTime = newParsedOpen;
    const timeToCheck = newParsedOpen;

    // Add 30 minutes to opening time to set the range
    newParsedOpen = newParsedOpen.clone().add(30, 'minute');

    // Check if current date is before timeToCheck (updated openingTime)
    if (currentDate.isBefore(timeToCheck)) {
      // Check if the current time is in line with closing and updated opening time
      const disabledOption =
        currentDate.isAfter(timeToCheck) && currentDate.isAfter(closingTimeMoment) && currentDate.isAfter(newParsedOpen);

      // If the updated opening time is after the closing time stop the parsing
      if (newParsedOpen.isAfter(closingTimeMoment)) {
        isFinished = true;
      } else {
        // Add range into to array
        timeRangeList.push(timeRangeToObject(rawTime, timeToCheck, newParsedOpen, disabledOption));
      }
    }
  }

  return timeRangeList.filter((el) => !moment(el.value).isBefore(moment()));
};

export const isoStringToLegibleString = (iso: string) => moment(iso).format('YYYY-MM-DD HH:mm');
